import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "width", "height", "viewBox", "disableAxisListener", "className", "sx"];
import { styled } from '@mui/material/styles';
import * as React from 'react';
import { useAxisEvents } from './hooks/useAxisEvents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChartChartsSurfaceStyles = styled('svg', {
  name: 'MuiChartsSurface',
  slot: 'Root'
})(() => ({}));
export const ChartsSurface = /*#__PURE__*/React.forwardRef(function ChartsSurface(props, ref) {
  const {
      children,
      width,
      height,
      viewBox,
      disableAxisListener = false,
      sx
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const svgView = _extends({
    width,
    height,
    x: 0,
    y: 0
  }, viewBox);
  useAxisEvents(disableAxisListener);
  return /*#__PURE__*/_jsxs(ChartChartsSurfaceStyles, _extends({
    width: width,
    height: height,
    viewBox: `${svgView.x} ${svgView.y} ${svgView.width} ${svgView.height}`,
    ref: ref,
    sx: [{
      '--ChartsLegend-itemWidth': '100px',
      '--ChartsLegend-itemMarkSize': '20px',
      '--ChartsLegend-rootSpacing': '5px',
      '--ChartsLegend-labelSpacing': '5px',
      '--ChartsLegend-rootOffsetY': '-20px'
    }, ...(Array.isArray(sx) ? sx : [sx])]
  }, other, {
    children: [/*#__PURE__*/_jsx("title", {
      children: props.title
    }), /*#__PURE__*/_jsx("desc", {
      children: props.desc
    }), children]
  }));
});